import store from "../../index.js";
import api from "../../../utils/api";
import axios from "axios";
import dobyConstant from "@/mixins/doby/dobyConstant.js";
import dobyAcConstant from "@/mixins/doby/dobyAcConstant.js";
import reviewAcConstant from "@/mixins/doby/reviewAcConstant.js";
import { callGetApi, callPostApi } from "@/utils/apiWrapper";
import {
  DOBY_TRANSFER_STATUS,
  DOBY_STATUS,
  DOBY_PAY_ORDER_STATUS,
  DOBY_PAYMENT_TYPE,
  DOBY_STATE,
} from "@/enum/doby";

export const modules = {
  store,
};

export const state = {
  _showDobyFunnelNavigator: false,
  _register: {
    ownerName: "",
    ownerAccount: "",
    ownerBank: "",
    senderName: "",
    paymentDate: "",
    paymentType: "",
    rentAmount: "",
    rentAmountNum: 0,
  },
  _doby: {
    comment: "",
    dobyAmount: 0,
    dobyDate: 0,
    ownerName: "",
    ownerAccount: "",
    ownerBank: "",
    paymentType: "",
    senderName: "",
    status: "",
    billingHistory: [],
    payHistoryList: [],
    registeredCards: [],
  },
  _dobyList: [],
  _files: [],
  _error: {
    code: 0,
    message: "",
  },
};

export const mutations = {
  [dobyConstant.SET_REGISTER_OWNER](state, payload) {
    state._register.ownerName = payload.ownerName;
    state._register.ownerAccount = payload.ownerAccount;
    state._register.ownerBank = payload.ownerBank;
    state._register.ownerBankCode = payload.ownerBankCode;
    state._register.senderName = payload.senderName;
    // window.console.log("state._register", state._register);
  },
  [dobyConstant.SET_REGISTER_DATE](state, payload) {
    state._register.paymentDate = payload.paymentDate;
    state._register.paymentType = payload.paymentType;
    state._register.rentAmount = payload.rentAmount;
    state._register.rentAmountNum = payload.rentAmountNum;
    // window.console.log("state._register", state._register);
  },
  [dobyConstant.SET_DOBY](state, payload) {
    state._doby = payload;
    console.log("state._doby", state._doby);
  },
  [dobyConstant.SET_DOBY_LIST](state, payload) {
    state._dobyList = payload;
    console.log("state._dobyList", state._dobyList);
  },
  [dobyConstant.SET_DOBY_FILES](state, payload) {
    state._files = [];
    state._files = payload;
    console.log("state._files", state._files);
  },
  [dobyConstant.SET_ERROR](state, payload) {
    state._error = payload;
    console.log("state._error", state._error);
  },
  [dobyConstant.SET_RESET](state) {
    (state._register = {
      ownerName: "",
      ownerAccount: "",
      ownerBank: "",
      ownerBankCode: "",
      senderName: "",
      paymentDate: "",
      paymentType: "",
      rentAmount: "",
    }),
      (state._doby = {
        comment: "",
        dobyAmount: 0,
        dobyDate: 0,
        ownerName: "",
        ownerAccount: "",
        ownerBank: "",
        ownerBankCode: "",
        paymentType: "",
        senderName: "",
        status: "",
        billingHistory: [],
      }),
      (state._files = []),
      (state._error = {
        code: 0,
        message: "",
      });
  },
};

export const actions = {
  async acDoby({ commit }) {
    const url = dobyAcConstant.GET_DOBY;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit(dobyConstant.SET_DOBY, res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyList({ commit }) {
    const url = dobyAcConstant.GET_DOBY_LIST;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit(dobyConstant.SET_DOBY_LIST, res.data.data);
      }
      return res.data?.code === 0 && res.data?.data?.length > 0;
    } catch (error) {
      return false;
    }
  },
  async acDobyDetailDeprecated({ commit }) {
    const url = dobyAcConstant.GET_DOBY_DETAIL_DEPRECATED;
    try {
      const res = await api.get(`${url}`);
      if (res.data?.code === 0 && res.data.data) {
        commit(dobyConstant.SET_DOBY, res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyDetail({ commit }, { encodedDobySeq }) {
    const url = dobyAcConstant.GET_DOBY_DETAIL;
    try {
      const res = await api.get(`${url}/${encodedDobySeq}`);
      if (res.data?.code === 0 && res.data.data) {
        commit(dobyConstant.SET_DOBY, res.data.data);
      }
      return res.data?.code === 0 && res.data?.data !== null;
    } catch (error) {
      return false;
    }
  },
  async acDobyFiles({ commit }, { encoded_doby_seq }) {
    const url = dobyAcConstant.GET_DOBY_FILES;
    try {
      const res = await api.get(`${url}/${encoded_doby_seq}`);
      if (res.data?.code === 0 && res.data.data?.length) {
        commit(dobyConstant.SET_DOBY_FILES, res.data.data);
      }
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  async acDobyLoadFile({ commit }, payload) {
    try {
      const response = await axios.get(payload, {
        responseType: "blob",
      });
      return response.data;
    } catch (error) {
      return null;
    }
  },
  async acDobySaveFile({ commit }, { encoded_doby_seq, formData }) {
    const url = dobyAcConstant.POST_DOBY_SAVE_FILE;
    try {
      const res = await api.post(`${url}/${encoded_doby_seq}`, formData);
      return { success: res.data?.code === 0 };
    } catch (error) {
      return { success: false, message: error.response?.data?.message };
    }
  },
  async acDobyCancel({ commit }, { status, encoded_doby_seq, cancel_type }) {
    const url = dobyAcConstant.POST_DOBY_CANCEL;
    try {
      const res = await api.post(`${url}/${encoded_doby_seq}`, {
        status,
        cancel_type,
      });
      return res.data?.code === 0;
    } catch (error) {
      commit(dobyConstant.SET_ERROR, error.response.data);
      return false;
    }
  },

  // 송금 계좌 예금주 확인하기
  async acDobyOwnerBankCheck({ commit }, payload) {
    const url = dobyAcConstant.GET_DOBY_OWNER_BANK_CHECK;
    try {
      const res = await api.get(url, {
        params: payload,
      });
      return res.data?.code === 0 ? res.data.data : false;
    } catch (error) {
      return false;
    }
  },
  // 도비 상세 정보 입력 (소유주 계좌, 송금자명 등).
  async acDobyEnterDetail({ commit }, { encodedDobySeq, params }) {
    const url = dobyAcConstant.POST_DOBY_ENTER_DETAIL;
    try {
      const payload = {
        owner_name: params.owner_name,
        owner_account: params.owner_account,
        owner_bank: params.owner_bank,
        owner_bank_code: params.owner_bank_code,
        sender_name: params.sender_name,
      };
      const res = await api.post(`${url}/${encodedDobySeq}`, payload);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },

  // 도비 일시납에서 정기결제로 변경.
  async acDobyConvertToMonthly({ commit }, { encodedDobySeq }) {
    const url = dobyAcConstant.POST_DOBY_CONVERT_TO_MONTHLY;
    try {
      const res = await api.post(`${url}/${encodedDobySeq}`);
      return {
        success: res.data?.code === 0,
        message: res.data?.message,
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message,
      };
    }
  },

  // ── 월세페이 후기(리뷰) — NZSC-3259 ──
  // 작성 자격(월세페이 결제 유무). 로그인 필요, 반환 { eligible: boolean }.
  async acGetWolseReviewEligibility() {
    return await callGetApi({ url: reviewAcConstant.GET_WOLSE_REVIEW_ELIGIBILITY });
  },
  // 내 후기 목록. 로그인 필요, 반환 [{ rating, content, created_date, ... }].
  async acGetMyWolseReviews() {
    return await callGetApi({ url: reviewAcConstant.GET_WOLSE_REVIEW_MINE });
  },
  // 후기 작성. 미자격이면 서버 403 → apiWrapper 가 null 반환(호출부에서 팝업 처리).
  async acCreateWolseReview(_ctx, { rating, content }) {
    return await callPostApi({
      url: reviewAcConstant.POST_WOLSE_REVIEW,
      data: { rating, content },
    });
  },

  // 도비 등록 카드 조회.
  async acDobyRegisteredCards({ commit }, { encodedDobySeq }) {
    const url = dobyAcConstant.GET_DOBY_REGISTERED_CARD;
    try {
      const res = await api.get(`${url}/${encodedDobySeq}`);
      return {
        success: res.data?.code === 0,
        message: res.data?.message,
        data: res.data?.data ?? [],
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message,
        data: null,
      };
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "";
      case 3004:
        return "송금 예정일에는 결제 취소가 불가합니다. 고객센터에 문의해 주세요. (송금이 진행된 이후라면 고객 센터를 통해서도 결제 취소가 불가합니다.)";
    }
  },
  getDobyTransferHistory: state => {
    return (
      state._doby.payHistoryList?.filter(
        phl => phl.transfer?.billingStatus === DOBY_TRANSFER_STATUS.SUCCESS,
      ) ?? []
    );
  },
  getDobyWithState: state => {
    return getDobyWithState(state._doby);
  },
  getDobyWithStateList: state => {
    return state._dobyList.map(doby => {
      return getDobyWithState(doby);
    });
  },
};

const getDobyWithState = doby => {
  const allPaymentsFulfilled = doby.payHistoryList
    ?.filter(ph => ph.payStatus === DOBY_PAY_ORDER_STATUS.COMPLETED)
    ?.every(
      ph => ph.transfer != null && ph.transfer.billingStatus === DOBY_TRANSFER_STATUS.SUCCESS,
    );
  const recentlyCanceled = (() => {
    let refundFirstSeen = false;
    let paidFirstSeen = false;
    doby.payHistoryList?.forEach(ph => {
      if (ph.payStatus === DOBY_PAY_ORDER_STATUS.COMPLETED) {
        if (!refundFirstSeen) paidFirstSeen = true;
      }
      if (ph.payRefundRequest === true) {
        if (!paidFirstSeen) refundFirstSeen = true;
      }
    });
    return refundFirstSeen;
  })();
  const fileExists = doby.files?.length > 0;
  let state = DOBY_STATE.LIVE;
  switch (doby.status) {
    case DOBY_STATUS.CONFIRM: {
      if (
        doby.paymentType === DOBY_PAYMENT_TYPE.ONE_TIME &&
        allPaymentsFulfilled /** 결제 됐고 해당하는 송금도 있는 경우 */
      ) {
        state = DOBY_STATE.STOPPED_ONE_TIME;
      } else {
        state = DOBY_STATE.LIVE;
      }
      break;
    }
    case DOBY_STATUS.REVIEW: {
      if (fileExists) {
        state = DOBY_STATE.REVIEWING;
      } else {
        state = DOBY_STATE.UNREGISTERED;
      }
      break;
    }
    case DOBY_STATUS.REJECT: {
      state = DOBY_STATE.REJECTED;
      break;
    }
    case DOBY_STATUS.CANCEL: {
      if (doby.paymentType === DOBY_PAYMENT_TYPE.MONTHLY) {
        if (doby.cancelType === "termination") {
          state = DOBY_STATE.CANCELLED_MONTHLY;
        } else {
          state = DOBY_STATE.CANCELLED_ONE_TIME;
        }
      } else {
        state = DOBY_STATE.CANCELLED_ONE_TIME;
      }
      break;
    }
    default:
      break;
  }
  return {
    data: doby,
    state,
    status: {
      isConfirm: doby.status === DOBY_STATUS.CONFIRM,
      isReview: doby.status === DOBY_STATUS.REVIEW,
      isReject: doby.status === DOBY_STATUS.REJECT,
      isCancel: doby.status === DOBY_STATUS.CANCEL,
    },
    fileExists,
  };
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
